import {
  BURBANK_CLIMATE_PLANS_SLUG,
  BURBANK_GEOID,
  BURBANK_GEOID_NUMERIC,
  BURBANK_LOCATION_NAME,
  BWP_EIA861_ANNUAL_OBSERVATIONS,
  BWP_EIA_UTILITY_ID,
  BWP_EXPECTED_UTILITY_NAME,
} from './bwpObservations';
import type { Eia861PilotUtilityConfig } from './types';
import { getBwpSourceCompleteness } from './sourceCompleteness';

/** Pilot registry: GEOID → EIA utility ID (not utility name). */
export const EIA861_UTILITY_PILOT_REGISTRY: Eia861PilotUtilityConfig[] = [
  {
    geoid: BURBANK_GEOID,
    geoidNumeric: BURBANK_GEOID_NUMERIC,
    climatePlansSlug: BURBANK_CLIMATE_PLANS_SLUG,
    locationName: BURBANK_LOCATION_NAME,
    eiaUtilityId: BWP_EIA_UTILITY_ID,
    expectedUtilityName: BWP_EXPECTED_UTILITY_NAME,
    observations: BWP_EIA861_ANNUAL_OBSERVATIONS,
  },
];

export function resolveEia861PilotForGeofips(geofips: number | string): Eia861PilotUtilityConfig | null {
  const norm = String(geofips).replace(/^0+/, '') || '0';
  const cfg = EIA861_UTILITY_PILOT_REGISTRY.find((r) => r.geoid.replace(/^0+/, '') === norm) ?? null;
  if (!cfg) return null;
  if (!getBwpSourceCompleteness().source_range_complete) return null;
  return cfg;
}

export function resolveEia861PilotForLocation(location: string): Eia861PilotUtilityConfig | null {
  const key = location.trim().toLowerCase();
  return (
    EIA861_UTILITY_PILOT_REGISTRY.find((r) => r.locationName.toLowerCase() === key) ?? null
  );
}
